/* eslint-disable @typescript-eslint/no-explicit-any */
import { Avatar, Flex, Select } from 'antd';
import { useLanguage } from 'hooks/Language/useLanguage';
import { IFormattedContactAccountNumber } from 'interfaces/components/pageProps';
import { IDisplayContactAccountNumbers } from 'interfaces/queries/transactions';
import { useState } from 'react';

const { Option } = Select;

interface ContactDropdownProps {
  options?: any[];
  loading?: boolean;
  size?: string;
  contact: any;
  setContact: any;
}

interface SelectOption {
  key: number;
  text: string;
  value: string;
  icon: string;
  FirstName?: string;
  LastName?: string;
}

const ContactDropdown: React.FC<ContactDropdownProps> = ({
  options,
  loading,
  size,
  contact,
  setContact,
}) => {
  const { translate } = useLanguage();
  const onChange = (value: any) => {
    const selected = options?.find(
      (option: any) => option.value === value?.value,
    );

    setContact({
      value: value?.value,
      label: selected
        ? renderSelectContactValue(selected)
        : undefined,
      operator: value?.Operator || selected?.Operator || {},
    });
  };

  return (
    <Select
      labelInValue
      size="large"
      value={contact?.value ? contact : undefined}
      placeholder={translate('Select a recipient')}
      loading={loading}
      onChange={onChange}
      optionLabelProp="value"
      style={{ width: `${size}` }}
    >
      {options &&
        options.map((option: any) => renderContactOption(option))}
    </Select>
  );
};

export const renderContactOption = (option: SelectOption) => {
  return (
    <Option key={option.key} value={option.value}>
      <Flex gap="small" justify="flex-start" vertical>
        <Flex gap="small" align="center">
          <Avatar
            icon={
              <ImageWithFallback
                src={option.icon}
                alt="contact logo"
                firstName={option.FirstName}
                lastName={option.LastName}
              />
            }
          />
          <Flex vertical>
            <Flex gap="small">
              <span>{option.text}</span>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Option>
  );
};

export const ImageWithFallback = ({
  src,
  alt,
  firstName,
  lastName,
}: any) => {
  const [imgError, setImgError] = useState(false);

  const handleError = () => {
    setImgError(true);
  };

  const getInitials = () => {
    const firstInitial =
      firstName && firstName.charAt(0).toUpperCase();
    const lastInitial = lastName && lastName.charAt(0).toUpperCase();
    return `${firstInitial}${lastInitial}`;
  };

  return (
    <>
      {!imgError ? (
        <img src={src} alt={alt} onError={handleError} />
      ) : (
        <span className="medium-text small-margin-top">
          {getInitials()}
        </span>
      )}
    </>
  );
};

export const renderSelectContactValue = (option: SelectOption) =>
  option?.value && (
    <Flex align="center" gap="small">
      <Avatar
        icon={
          <ImageWithFallback
            src={option.icon}
            alt="contact logo"
            firstName={option.FirstName}
            lastName={option.LastName}
          />
        }
      />
      <span>{option?.text}</span>
    </Flex>
  );

export const formattedContactAccountList = (
  accountData: any[] | undefined,
): IFormattedContactAccountNumber[] =>
  accountData?.map(
    (item: IDisplayContactAccountNumbers, index: any) => ({
      key: index,
      text: `${item.FirstName || ''} ${item?.LastName || ''}`,
      value: item.DefaultWallet?.WalletNumber ?? item?.AccountNumber,
      icon: item.PictureURL || '',
      FirstName: item.FirstName || '',
      LastName: item.LastName || '',
      PhoneNUmber: item?.PhoneNumber || '',
      Operator: item?.Operator,
    }),
  ) || [];

export default ContactDropdown;
